<template>
  <v-card class="regions-search__bar px-3">
    <v-form class="search-form" @submit.prevent="pathToSearchResult({ isEnter: true })">
      <v-row no-gutters class="flex-wrap">
        <v-col v-if="showCategoryAndNow" class="bar__col--vertical-divider my-3" cols="auto">
          <v-menu v-model="categoryMenu" min-width="264" max-height="384" offset="16" z-index="3" slide-x>
            <template #activator="{ props, isActive }">
              <v-btn class="filter__btn mx-3 px-3" :color="isActive ? 'orange50' : ''" height="40" variant="text" v-bind="props">
                <FunnowSvgIcon class="mr-2" max-width="24" :image-path="'funnow-icon.svg'" />
                {{ selectedCategory.name || $t('filter_category') }}
              </v-btn>
            </template>

            <v-list :selected="selectedCategory.id || 0" color="orange50" mandatory>
              <v-list-item
                v-for="(category, idx) in categories"
                :key="idx"
                :value="category.id"
                color="orange50"
                :active="category.id === selectedCategory.id"
                @click="onClickCategory({ params: { categoryID: category.id } })"
              >
                <v-list-item-title> {{ category.name }} </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>

        <v-col v-if="showCategoryAndNow" class="bar__col--vertical-divider my-3" cols="auto">
          <v-btn
            class="filter__btn mx-3 px-3"
            :class="{ selected: filterNow.activated }"
            min-width="100"
            height="40"
            variant="text"
            @click="clickNowFilter"
          >
            <FunnowSvgIcon class="mr-2" max-width="24" :image-path="'flash-icon_current.svg'" />
            {{ $t('filter_now') }}
          </v-btn>
        </v-col>

        <v-col class="bar__col--vertical-divider my-3" cols="auto">
          <v-menu v-model="dateMenuValue" :close-on-content-click="false" offset="16" z-index="3" location="bottom">
            <template #activator="{ props, isActive }">
              <v-btn
                class="filter__btn filter__btn--date mx-3 px-3"
                :color="isActive || filterDate.activated || false ? 'orange50' : ''"
                min-width="100"
                height="40"
                variant="text"
                v-bind="props"
              >
                <FunnowSvgIcon class="mr-2" max-width="24" :image-path="'calendar-icon.svg'" />
                <span class="btn__text"> {{ filterDate.text || $t('filter_date') }} </span>
              </v-btn>
            </template>

            <FilterMenuCard
              v-if="dateMenuValue"
              :title="filterDate.title"
              :filter-value="filterDate.value"
              :filter-options="filterDate.options"
              :filter-selected="filterDate.activated"
              :current-filter="currentFilter"
              :date-mode="filterDate.dayMode"
              :total-count="totalCount"
              :key-value="filterDate.keyValue"
              :is-branch-card-mode="isBranchCardMode"
              :clear-btn="true"
              :menu-width="480"
              filter-key="date"
              content-type="date-picker"
              @confirm="updateFilterCondition"
            />
          </v-menu>
        </v-col>

        <v-col class="bar__col--vertical-divider my-3" cols="auto">
          <TimeFilterMenu
            :display-text="filterTime.text"
            :activated="filterTime.activated"
            :selected-times="filterTime.value"
            :key-value="filterTime.keyValue"
            :current-filter="currentFilter"
            :total-count="totalCount"
            :is-branch-card-mode="isBranchCardMode"
            @confirm="updateFilterCondition"
          />
        </v-col>

        <v-col class="bar__col--vertical-divider my-3 mr-3" cols="auto">
          <v-menu
            v-model="headCountMenuValue"
            :disabled="disabledHeadCount"
            :close-on-content-click="false"
            :offset="[0, 0, 16, 0]"
            z-index="3"
            location="bottom"
          >
            <template #activator="{ props, value }">
              <v-btn
                class="filter__btn mx-3 px-3"
                :color="value || filterHeadCount.activated || false ? 'orange50' : ''"
                :disabled="disabledHeadCount"
                min-width="100"
                height="40"
                variant="text"
                v-bind="props"
              >
                <FunnowSvgIcon class="mr-2" max-width="24" :image-path="'member-icon.svg'" />
                {{ filterHeadCount.text || $t('filter_pax') }}
              </v-btn>
            </template>

            <FilterMenuCard
              v-if="headCountMenuValue"
              :title="filterHeadCount.title"
              :filter-value="filterHeadCount.value"
              :filter-options="filterHeadCount.options"
              :current-filter="currentFilter"
              :date-mode="filterHeadCount.dayMode"
              :total-count="totalCount"
              :key-value="filterHeadCount.keyValue"
              :is-branch-card-mode="isBranchCardMode"
              filter-key="headcount"
              content-type="list"
              @confirm="updateFilterCondition"
            />
          </v-menu>
        </v-col>

        <v-col class="my-3">
          <div class="d-flex">
            <v-menu
              v-model="searchMenu"
              :close-on-content-click="false"
              max-width="728"
              width="728"
              max-height="280"
              offset="16"
              z-index="3"
              location="bottom"
              slide-x
            >
              <template #activator="{ props }">
                <v-text-field
                  v-model="inputKeyword"
                  class="search-input wd-h-10 wd-w-full"
                  :placeholder="searchPlaceholder"
                  autocomplete="off"
                  color="orange50"
                  variant="solo"
                  flat
                  density="compact"
                  hide-details
                  v-bind="props"
                  @keydown.down.capture.stop=""
                  @keydown.up.capture.stop=""
                  @update:model-value="inputSearchKeywords"
                />
              </template>

              <search-content-card
                ref="searchContentCard"
                :popular-keywords="effectivePopularKeywords"
                :history-key-words="effectiveHistoryKeyWords"
                @change-keyword="onClickKeyword"
              />
            </v-menu>
            <!-- PM: 點擊 search icon 視同 Enter 送出搜尋 -->
            <v-btn
              class="search__btn"
              min-width="40"
              width="40"
              height="40"
              color="orange50"
              variant="flat"
              @click="pathToSearchResult({ isEnter: true })"
            >
              <div class="wd-w-7 wd-h-7 wd-flex wd-justify-center wd-items-center">
                <FunnowSvgIcon image-path="magnify-icon_white.svg" />
              </div>
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-form>
  </v-card>
</template>

<script>
import regionFilterSetting from '@/composition/region-filter-setting'
import { useGtm, useGtmSearchQuerySent } from '@/composition/useGtm'
import { GtmEventMap } from '@/view-models/gtm'

import FunnowSvgIcon from '@/components/icons/funnow-svg-icon.vue'
const FilterMenuCard = defineAsyncComponent(() => import('@/components/page/categories/filter-menu-card.vue'))
const TimeFilterMenu = defineAsyncComponent(() => import('@/components/page/regions/time-filter-menu.vue'))
const SearchContentCard = defineAsyncComponent(() => import('@/components/search/search-content-card.vue'))

export default defineComponent({
  name: 'RegionsSearchBar',
  components: {
    FilterMenuCard,
    TimeFilterMenu,
    SearchContentCard,
    FunnowSvgIcon,
  },
  props: {
    allRegions: { type: Array, default: () => [] },
    region: { type: Object, default: () => ({}) },
    categories: { type: Array, default: () => [] },
    dataCount: { type: Number, default: 0 },
    searchParams: { type: Object, default: () => ({}) },
    searchKeyWord: { type: String, default: '' },
    searchKeywordsOfRegion: { type: Array, default: () => [] },
    historyKeyWords: { type: Array, default: () => [] },
    headcountOptions: { type: Array, default: () => [] },
    isBranchCardMode: { type: Boolean, default: true },
    showCategoryAndNow: { type: Boolean, default: true },
  },
  emits: ['updateFilterData', 'updateSearchKeyword'],
  setup(props) {
    const { sendGtmEvent } = useGtm()
    const { keywordSource, fireSearchQuerySentEvent } = useGtmSearchQuerySent()
    const {
      filterNow,
      filterDate,
      filterTime,
      filterHeadCount,
      currentFilter,
      selectedCategory,
      initSearchBar,
      setSearchKeyWord,
      updateCondition,
      onClickCategory,
      clickNowFilter,
      syncFiltersFromStore,
    } = regionFilterSetting(props)
    const localePath = useLocalePath()

    return {
      sendGtmEvent,
      keywordSource,
      fireSearchQuerySentEvent,
      filterNow,
      filterDate,
      filterTime,
      filterHeadCount,
      currentFilter,
      selectedCategory,
      initSearchBar,
      setSearchKeyWord,
      updateCondition,
      onClickCategory,
      clickNowFilter,
      syncFiltersFromStore,
      localePath,
    }
  },
  data() {
    return {
      regionMenu: false,
      categoryMenu: false,
      dateMenuValue: false,
      headCountMenuValue: false,
      searchMenu: false,
      inputKeyword: this.searchKeyWord || '',
      totalCount: this.dataCount || 0,
    }
  },
  computed: {
    loggedInUser() {
      return this.$auth.user
    },
    nowRegionID() {
      return this.region.id
    },
    searchPlaceholder() {
      return this.$t('search_region_placeholder', { region: this.region.name })
    },
    disabledHeadCount() {
      if (this.isListPage) return false
      return this.filterHeadCount.options.length <= 0
    },
    storeFilters() {
      return this.$store.getters['filter/filters']
    },
    effectivePopularKeywords() {
      if (this.isListPage) return this.$store.getters['search/searchKeywordsOfCategory']
      return this.searchKeywordsOfRegion
    },
    effectiveHistoryKeyWords() {
      if (this.isListPage) return this.$store.getters['search/searchKeywordsOfHistory']
      return this.historyKeyWords
    },
    storeSearchKeyword() {
      return this.$store.getters['search/searchKeyword']
    },
    isListPage() {
      const routeName = this.$route?.name
      return checkIfRegionCategoriesPage(routeName) || checkIfRegionThemesPage(routeName)
    },
  },
  watch: {
    headcountOptions: {
      handler(newOptions) {
        if (this.isListPage && newOptions && newOptions.length > 0) {
          Object.assign(this.filterHeadCount, { options: newOptions })
        }
      },
    },
    storeFilters(newFilters) {
      if (this.isListPage && this.filterDate.options && this.filterDate.options.length > 0) {
        this._syncFiltersFromStore(newFilters)
      }
    },
    dataCount(newCount) {
      this.totalCount = newCount
    },
    searchKeyWord(newKeyWord) {
      this.inputKeyword = newKeyWord
    },
    storeSearchKeyword(newVal) {
      if (this.isListPage) {
        this.inputKeyword = newVal || ''
      }
    },
  },
  created() {
    this.initSearchBar()
    if (this.isListPage) {
      this.inputKeyword = this.storeSearchKeyword || ''
      const unwatch = this.$watch(
        () => this.filterDate.options,
        newOptions => {
          if (newOptions && newOptions.length > 0) {
            unwatch()
            // Inject headcount options from parent (category-info-sheet) after initFilterChips() runs
            if (this.headcountOptions && this.headcountOptions.length > 0) {
              Object.assign(this.filterHeadCount, { options: this.headcountOptions })
            }
            this._syncFiltersFromStore(this.storeFilters)
          }
        },
        { immediate: true }
      )
    }
  },
  methods: {
    _syncFiltersFromStore(filters) {
      this.syncFiltersFromStore(filters)
    },
    closedMenu(filterKey) {
      switch (filterKey) {
        case 'date':
          this.dateMenuValue = false
          break
        case 'headcount':
          this.headCountMenuValue = false
          break
      }
    },
    async handleRedirectToRegion(region) {
      const regionId = region.region_id
      const event = {
        event: GtmEventMap.REGION_CHANGED,
        payload: {
          'To Region ID': regionId,
          'To Region Name': region.name,
        },
      }

      this.sendGtmEvent(event, false)
      if (this.loggedInUser) {
        this.sendGtmEvent(event, true)
        await this.$store.dispatch('authentication/updateMemberRegion', { regionId, userInfo: this.loggedInUser })
      }

      this.$router.push(this.localePath({ name: 'regions-rid', params: { rid: regionId } }))
    },
    updateFilterCondition({ params, filterKey, activated, totalCount }) {
      this.closedMenu(filterKey)
      this.updateCondition({ params, filterKey, activated })
      this.totalCount = totalCount
      // Sync filter/filters store so other components (category-info-sheet) stay in sync
      if (filterKey === 'date') {
        this.$store.dispatch('filter/setFilters', { ...params, filter_time: null })
      } else {
        this.$store.dispatch('filter/setFilters', { ...params })
      }
      this.$emit('updateFilterData', { totalCount: totalCount, filters: params })
    },
    inputSearchKeywords(keyword) {
      // Only update local state while typing — search is triggered on explicit submit
      // (Enter key / search button via pathToSearchResult), not on every keystroke.
      if (!this.isListPage) {
        // 首頁：使用者手動編輯輸入框後，不再算 Hot Keyword 或 Search History
        this.keywordSource = ''
      }
      this.setSearchKeyWord(keyword)
      if (!this.isListPage) {
        this.updateSearchKeywords(keyword)
      }
    },
    onClickKeyword({ keyword, keywordSource }) {
      // Clicking a suggestion is an explicit selection — trigger search immediately.
      this.searchMenu = false
      this.inputKeyword = keyword
      this.keywordSource = keywordSource || ''
      this.setSearchKeyWord(keyword)
      if (this.isListPage) {
        // 列表頁選完 keyword 就立刻搜尋，所以在這裡 fire event
        // 首頁只更新 keyword，event 在使用者點搜尋按鈕時由 pathToSearchResult 送出
        this.fireSearchQuerySentEvent(this.buildSearchEventOptions({ keyword }))
        this.$store.dispatch('search/setSearchKeyword', keyword)
      }
    },
    updateSearchKeywords(keyword) {
      this.$emit('updateSearchKeyword', keyword)
    },
    pathToSearchResult(options = {}) {
      const { isEnter = false } = options
      const {
        starttime,
        endtime,
        filter_times: filterTimes,
        limit: headcount,
        filter_time: filterTime,
        filter_keyword: filterKeyword,
      } = this.currentFilter

      this.fireSearchQuerySentEvent(this.buildSearchEventOptions({ keyword: filterKeyword, isEnter }))

      // On list pages (categories/themes), dispatch to store so useRegionSearchNavigation
      // handles in-place re-fetch — same flow as components/search/search-bar.vue doSearch()
      if (this.isListPage) {
        if (filterKeyword) {
          this.$store.dispatch('search/saveHistorySearchKeyword', filterKeyword)
        }
        this.$store.dispatch('search/setSearchKeyword', filterKeyword || '')
        return
      }

      // Homepage: navigate to category/search page with full filter query
      const regionID = this.region.id
      const categoryID = this.selectedCategory.id

      const searchQuery = {
        starttime,
        endtime,
        filter_times: filterTimes,
        limit: headcount,
        filter_time: filterTime,
        filter_keyword: filterKeyword || undefined,
      }

      if (filterKeyword) {
        this.$store.dispatch('search/saveHistorySearchKeyword', filterKeyword)
      }

      if (categoryID) {
        this.$router.push(
          this.localePath({
            name: 'regions-rid-categories-id',
            params: { rid: regionID, id: categoryID },
            query: { ...searchQuery },
          })
        )
      } else {
        this.$router.push(this.localePath({ name: 'regions-rid-search', params: { rid: regionID }, query: { ...searchQuery } }))
      }
    },
    buildSearchEventOptions({ keyword, isEnter = false }) {
      return {
        keyword,
        isEnter,
        sourceName: this.$store.getters['category/firstLevelCategory']?.name || '',
        isListPage: this.isListPage,
        isEmbeddedSearchBarVisible: this.$store.getters.isEmbeddedSearchBarVisible,
      }
    },
  },
})
</script>

<style lang="scss" scoped>
.regions-search__bar {
  box-shadow: 0px 6px 16px -8px rgba(0, 0, 0, 0.16), 0px 9px 28px rgba(0, 0, 0, 0.1) !important;

  .bar {
    &__col {
      &--vertical-divider {
        border-right: 1px solid $gray40;
      }
    }
  }

  .filter__btn {
    font-size: 17px;

    &.selected {
      color: $orange50;
    }

    &--date {
      .btn__text {
        max-width: 110px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }

  .search-input {
    font-size: 17px;
    min-width: 178px;
  }
}
</style>
